import _extends from "@babel/runtime/helpers/esm/extends";
import React, { useEffect } from 'react';
import Input from './Input';
import { lengthValidator } from '../config';
function formatter(value) {
  if (!value) {
    return;
  }
  if (typeof value === 'string') {
    return value;
  } else {
    return value[1];
  }
}
export default (function (props) {
  var required = props.required,
    value = props.value; // const context = useContext(ConfigContext);

  var validator = function validator(value) {
    var reg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!value) {
      return required ? 'The Field is required' : undefined;
    }
    if (!reg.test(value)) {
      return 'Invalid email address';
    }
    return lengthValidator(value, props);
  };
  useEffect(function () {
    if (typeof props.value === 'string') {
      var _props$onChange;
      (_props$onChange = props.onChange) === null || _props$onChange === void 0 ? void 0 : _props$onChange.call(props, [props.region, props.value]);
    }
  }, [props.value]);
  var handleChange = function handleChange(v) {
    if (typeof props.value === 'string' || !props.value) {
      var _props$onChange2;
      (_props$onChange2 = props.onChange) === null || _props$onChange2 === void 0 ? void 0 : _props$onChange2.call(props, [props.region, v]);
    } else {
      var _props$onChange3, _props$value;
      (_props$onChange3 = props.onChange) === null || _props$onChange3 === void 0 ? void 0 : _props$onChange3.call(props, [(_props$value = props.value) === null || _props$value === void 0 ? void 0 : _props$value[0], v]);
    }
  };
  return /*#__PURE__*/React.createElement(Input, _extends({}, props, {
    value: formatter(value),
    validator: validator,
    onChange: handleChange,
    wrapperStyle: props.isCaseCreation ? {
      borderWidth: 0
    } : {}
  }));
});